import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import ProcessField from 'components/core/fields/ProcessField';
import Constants from 'utils/Constants';

import ProcessUtils from 'utils/ProcessUtils';
import InfoBoxLabel from 'components/core/InfoBoxLabel';

/**
 * Field component for setting bin alignment for a dimension
 */
export default class OutputIntervalTimezoneField extends ProcessField {

    static propTypes = Object.assign({
        outputDatastreamName: PropTypes.string
    }, ProcessField.propTypes);

    onFieldUpdated = (fieldPath, value) => {
        let newValue = value.value;
        if (newValue === 'utc') {
            newValue = null;
        }
        ProcessUtils.updateField(this.props.process, fieldPath, newValue);
    };

    render() {
        let interval = this.props.process.output_interval[this.props.outputDatastreamName].interval;
        let value = this.props.process.output_interval[this.props.outputDatastreamName].timezone;
        if (value === null) {
            value = 'utc';
        }
        value = Constants.getOptionById(value, Constants.OUTPUT_INTERVAL_TIMEZONE_OPTIONS);

        if (interval !== null) {
            return (
                <Flexbox className={this.props.className} flexDirection="row" alignItems="flex-start">
                    <InfoBoxLabel label="Interval Timezone"/>
                    <RIEComboBox
                        value={value}
                        options={Constants.OUTPUT_INTERVAL_TIMEZONE_OPTIONS}
                        change={this.onFieldUpdated}
                        fieldPath={['output_interval', this.props.outputDatastreamName, 'timezone']}
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                    />
                </Flexbox>
            );
        } else {
            return (<Flexbox/>)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/OutputIntervalTimezoneField.js